import store from '../store'

export default req => {
    return ({ status, body}) => {
        
        var rota = window._Vue.$router.app._route.name;


        const teacherRoutes = ['login/teacher', 'teacher/page', 'teacher-panel']
        const isTeacherRoute = teacherRoutes.includes(rota)

        if(isTeacherRoute){

            if(status === 401 && rota !== 'login/teacher'){
                window._Vue.$router.push({ name: 'login/teacher' });
            }

        }else if(rota != 'availability-teacher'){
            
            if(status === 203 || status === 401){

                if(body?.license_expired){ 
                    window._Vue.$router.push({ name: 'license-expired' });
                    return;
                }

                if(window._Vue.$router.app._route.name != 'login'){
                    store.dispatch('auth/ActionSignOut');
                    window._Vue.$router.push({ name: 'login' });
                }
            }

            if(status === 403) {
                window._Vue.$router.push({ name: '403'})
            }

            if(status === 500 || status === 422) {
                const errors = { message: body.message, url: req.url, status: status, errors: body?.errors || [] }
                store.dispatch('auth/ActionSetErrorsHttp', errors);
            }

            if(status === 503) {
                window._Vue.$router.push({ name: '503'})
            }

            // EP-958, Task 10 — backend devolve 423 Locked quando uma
            // chamada de API é interceptada pelo middleware de governança.
            // Hidrata o store e força o redirect — o overlay assume.
            if(status === 423 && body?.is_blocked) {
                store.dispatch('governance/ActionApplyLockedFromInterceptor', body)
                if(window._Vue.$router.app._route.name !== 'vacancy-control') {
                    window._Vue.$router.push({ name: 'vacancy-control' }).catch(() => {})
                }
            }
        }
    }
}